import { Link } from 'react-router-dom';

import { Box, Menu, Text } from '@zillow/constellation-10';

import { RMW_PATH } from '../../../../pathsManifest';
import NavItem from '../NavItem';
import { StyledTab, StyledTabsList } from '../../styles';
import { NAV_ITEM_TITLE } from '../../index';
import AppSelectors from '../../../../selectors/AppSelectors';
import { useSelector } from '../../../../selectors/useSelector';

type Props = {
  activePath: string;
  dashboardPathObj: { [key: string]: string };
};

const Navigation = ({ activePath, dashboardPathObj: DASHBOARD_PATH }: Props) => {
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  const renderOverflowNavItems = ({ isInMenuPopper = false }) => {
    const tabs = [
      {
        id: RMW_PATH.DASHBOARD_PAYMENTS,
        title: NAV_ITEM_TITLE.DASHBOARD_PAYMENTS,
        isActive: activePath === RMW_PATH.DASHBOARD_PAYMENTS,
        toPath: DASHBOARD_PATH.payments,
      },
      {
        id: RMW_PATH.DASHBOARD_MAINTENANCE_TASKS,
        title: NAV_ITEM_TITLE.DASHBOARD_MAINTENANCE_TASKS,
        isActive: activePath === RMW_PATH.DASHBOARD_MAINTENANCE_TASKS,
        toPath: DASHBOARD_PATH.maintenanceTasks,
      },
    ];

    if (isInMenuPopper) {
      return tabs.map((tab) => (
        <Menu.Item asChild key={tab.id}>
          <Link
            to={{
              pathname: tab.toPath,
            }}
          >
            <NavItem title={tab.title} isActive={tab.isActive} isInMenuPopper={isInMenuPopper} toPath={tab.toPath} />
          </Link>
        </Menu.Item>
      ));
    } else {
      return tabs.map((tab) => (
        <StyledTab value={tab.id} key={tab.id} id={tab.id}>
          <NavItem title={tab.title} isActive={tab.isActive} isInMenuPopper={isInMenuPopper} toPath={tab.toPath} />
        </StyledTab>
      ));
    }
  };

  return (
    <Box css={{ backgroundColor: 'bg.neutral' }}>
      <StyledTabsList aria-label="Navigation">
        <StyledTab value={RMW_PATH.DASHBOARD_OVERVIEW}>
          <NavItem
            title={NAV_ITEM_TITLE.DASHBOARD_OVERVIEW}
            isActive={activePath === RMW_PATH.DASHBOARD_OVERVIEW}
            toPath={DASHBOARD_PATH.overview}
          />
        </StyledTab>

        <StyledTab value={RMW_PATH.DASHBOARD_LISTING} id={RMW_PATH.DASHBOARD_LISTING}>
          <NavItem
            title={NAV_ITEM_TITLE.DASHBOARD_LISTING}
            isActive={activePath === RMW_PATH.DASHBOARD_LISTING}
            toPath={DASHBOARD_PATH.listing}
          />
        </StyledTab>

        <StyledTab value={RMW_PATH.DASHBOARD_APPLICATIONS} id={RMW_PATH.DASHBOARD_APPLICATIONS}>
          <NavItem
            title={NAV_ITEM_TITLE.DASHBOARD_APPLICATIONS}
            isActive={activePath === RMW_PATH.DASHBOARD_APPLICATIONS}
            toPath={DASHBOARD_PATH.applications}
          />
        </StyledTab>

        <StyledTab value={RMW_PATH.DASHBOARD_LEASES} id={RMW_PATH.DASHBOARD_LEASES}>
          <NavItem
            title={NAV_ITEM_TITLE.DASHBOARD_LEASES}
            isActive={activePath === RMW_PATH.DASHBOARD_LEASES}
            toPath={DASHBOARD_PATH.leases}
          />
        </StyledTab>

        {isScreenMobile ? (
          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              paddingRight: '400',
              alignItems: 'center',
            }}
          >
            <Menu content={renderOverflowNavItems({ isInMenuPopper: true })} />
            <Box css={{ marginBottom: '400' }}>
              <Text
                color="text.subtle"
                css={{
                  textStyle: 'body-xs',
                  '@media (min-width: 390px) and (max-width: 480px)': {
                    textStyle: 'body-sm',
                  },
                }}
              >
                More
              </Text>
            </Box>
          </Box>
        ) : (
          renderOverflowNavItems({ isInMenuPopper: false })
        )}
      </StyledTabsList>
    </Box>
  );
};

export default Navigation;
